import { Component, OnInit, HostListener } from '@angular/core';
import { Title }  from '@angular/platform-browser';
import { Location } from '@angular/common';
import { UserService } from './shared/services/user.service';
import { AuthService } from './shared/services/auth.service';
import { WindowRefService } from './shared/services/window-ref.service';

@Component({
  selector: 'my-app',
  template: require('./app.component.html'),
  styles: [require('./app.component.scss')]
})

export class AppComponent implements OnInit{

  private _window: Window;
  private currPos: Number = 0;
  private changePos: Number = 250;
  public showHide: boolean;

  constructor(public authService: AuthService,
              public us: UserService,
              private location: Location,
              private windowRef: WindowRefService,
              private titleService: Title){

    this.authService.returnUrl = this.location.path();
    this._window = this.windowRef.nativeWindow;

    // To zoom out to adjust to screen sizes less than 1440 and 1290
    if(this._window.innerWidth <= 1290){
      // this._window.document.body.style.zoom = '0.65';
    } else {
      if(this._window.innerWidth <= 1440){
        // this._window.document.body.style.zoom = '0.75';
      }
    }
  }

  ngOnInit(){
    this.us.getCountries().subscribe(() => {}, (err) => {console.log(err);}, ()=> {});
    this.us.getDefaultLabels().subscribe(() => {}, (err) => {console.log(err);}, ()=> {});
  };

  @HostListener('window:scroll', ['$event'])
  public doSomething(event) {
    this.currPos = (this._window.pageYOffset || event.target.scrollTop) - (event.target.clientTop || 0);
    if ((this.currPos >= this.changePos) && !location.pathname.includes('auth')) {
      this.showHide = true;
    } if (location.pathname.includes('auth')) {
      this.showHide = false;
    } else {
      this.showHide = false;
    }
  }

  // When the user clicks on the button, scroll to the top of the document
  public scrollToTop(scrollDuration) {
    let cosParameter = this._window.scrollY / 2;
    let scrollCount = 0;
    let oldTimestamp = performance.now();
    let doc = this._window;
    function step (newTimestamp) {
      scrollCount += Math.PI / (scrollDuration / (newTimestamp - oldTimestamp));
      if (scrollCount >= Math.PI) { doc.scrollTo(0, 0); }
      if (doc.scrollY === 0) { return; }
      doc.scrollTo(0, Math.round(cosParameter + cosParameter * Math.cos(scrollCount)));
      oldTimestamp = newTimestamp;
      doc.requestAnimationFrame(step);
    }
    this._window.requestAnimationFrame(step);
  }

  detectUrl(){
    if (location.pathname.includes('auth') || location.pathname.includes('user')) {
      const favicon = document.querySelector('link[rel*="icon"]') as HTMLLinkElement;
      if (this.us.client !== 'artists' && this.us.client !== 'bm') {
        favicon.href = "./img/umx-favicon.png";
      } else {
        favicon.href = "https://usaws09-umx-cdn-dev.s3.amazonaws.com/img/artists-favicon.png";
      }
    }
    if (!location.pathname.includes('auth') && !location.pathname.includes('user')) {
      const favicon = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
      favicon.href = "./img/dizzee-favicon.png";
      if (location.pathname.includes('list')) {
        this.titleService.setTitle('Dizzee - Internal Users');
      } else if (location.pathname.includes('external')) {
        this.titleService.setTitle('Dizzee - External Users');
      } else if (location.pathname.includes('requests')) {
        this.titleService.setTitle('Dizzee - Invite Requests');
      } else if (location.pathname.includes('help')) {
        this.titleService.setTitle('Dizzee - Help');
      } else if (location.pathname.includes('restrictions')) {
        this.titleService.setTitle('Dizzee - Feature Restrictions');
      } else {
        this.titleService.setTitle('Dizzee');
      }
    }
    if(this.authService.returnUrl.indexOf('/auth/okta') === -1 &&
      this.authService.returnUrl.indexOf('/user/detect')=== -1 &&
      this.authService.returnUrl.indexOf('/auth/activation')=== -1 &&
      this.authService.returnUrl.indexOf('/auth/password-reset')=== -1) {
      // console.log('detect url true');
      return true;
    } else {
      // console.log('detect url false');
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./src/app/app.component.ts